import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogContent } from '../../../models/dialogs/dialog-content';

@Component({
  selector: 'app-relogin-dialog',
  imports: [MatDialogModule],
  templateUrl: './relogin-dialog.component.html',
  styleUrl: './relogin-dialog.component.scss',
})
export class ReloginDialogComponent {
  dialogRef = inject<MatDialogRef<ReloginDialogComponent>>(MatDialogRef);
  dialogContent = inject<DialogContent>(MAT_DIALOG_DATA);
}
